module.exports = __webpack_public_path__ + "img/btn.d2394869.png";